export default "__VITE_ASSET__BBK6WJYV__"